import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../../../../../utils/Helpers";
import {
  formatPayrollAmount,
  formatPayrollCurrency,
} from "../utils/formatPayrollValue";

const EventPayrollBulkSummaryCards = ({ items, currency }) => (
  <div className="event-payroll-generate__total-cards">
    {items.map((item) => (
      <div
        key={item.key}
        className={clx(
          "event-payroll-generate__total-card",
          item.tone && `event-payroll-generate__total-card--${item.tone}`,
        )}
      >
        <span className="event-payroll-generate__total-card-label text-label-lg">
          {item.label}
        </span>
        <span
          className={clx("event-payroll-generate__total-card-value", {
            "event-payroll-generate__total-card-value--total-salary":
              item.isTotalSalary,
          })}
        >
          {item.isCurrency
            ? formatPayrollCurrency(item.value, currency)
            : formatPayrollAmount(item.value, { signed: true })}
        </span>
      </div>
    ))}
  </div>
);

EventPayrollBulkSummaryCards.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.number,
      tone: PropTypes.oneOf(["destructive", "success", "primary"]),
      isCurrency: PropTypes.bool,
      isTotalSalary: PropTypes.bool,
    }),
  ).isRequired,
  currency: PropTypes.string,
};

EventPayrollBulkSummaryCards.defaultProps = {
  currency: "",
  isTotalSalary: false,
};

export default EventPayrollBulkSummaryCards;
